import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "image-operation"
};
import { Delete, View, Download } from '@element-plus/icons-vue';
import { toRefs, watch } from 'vue';
import { onMounted, ref } from 'vue';
import { Markmap } from 'markmap-view';
import { Transformer } from 'markmap-lib';
import download from '@/utils/download';
export default /*@__PURE__*/_defineComponent({
  __name: 'ItemCard',
  props: {
    detail: {
      type: Object,
      require: true
    }
  },
  emits: ['onBtnClick', 'onMjBtnClick'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const svgRef = ref();
    let markMap = null;
    const transformer = new Transformer();
    const cardImageRef = ref(); // 卡片 image ref
    const emits = __emit; // emits
    /** 处理点击事件  */
    const handleButtonClick = async (type, detail) => {
      emits('onBtnClick', type, detail);
    };
    /** 监听详情 */
    const {
      detail
    } = toRefs(props);
    // 监听内容变化并重新渲染
    watch(() => props.detail?.generatedContent, () => {
      renderMindMap();
    });
    // 渲染思维导图
    const renderMindMap = () => {
      try {
        if (!props.detail?.generatedContent) return;
        // 转换Markdown为思维导图数据
        const {
          root
        } = transformer.transform(props.detail.generatedContent);
        // 设置数据并适配视图
        markMap?.setData(root);
        markMap?.fit();
      } catch (e) {
        console.error('渲染思维导图失败:', e);
      }
    };
    /** 初始化 */
    onMounted(async () => {
      if (!props.detail?.generatedContent) {
        return;
      }
      // 初始化思维导图
      if (svgRef.value) {
        markMap = Markmap.create(svgRef.value, {
          autoFit: true,
          // 自动适配内容
          fitRatio: 0.8,
          // 适配比例
          paddingX: 20 // 水平内边距
        });
        renderMindMap();
      }
    });
    /** 下载图片：download SVG to png file */
    const downloadImage = () => {
      const svgElement = cardImageRef.value;
      // 将 SVG 渲染到图片对象
      const serializer = new XMLSerializer();
      const source = `<?xml version="1.0" standalone="no"?>\r\n${serializer.serializeToString(svgRef.value)}`;
      const base64Url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(source)}`;
      download.image({
        url: base64Url,
        canvasWidth: svgElement?.offsetWidth,
        canvasHeight: svgElement?.offsetHeight,
        drawWithImageSize: false
      });
    };
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        "body-class": "",
        class: "image-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
          class: "w-[150px] mb-2",
          truncated: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detail)?.prompt), 1)]),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Download),
          onClick: downloadImage
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Delete),
          onClick: _cache[0] || (_cache[0] = $event => handleButtonClick('delete', _unref(detail)))
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(View),
          onClick: _cache[1] || (_cache[1] = $event => handleButtonClick('view', _unref(detail)))
        }, null, 8, ["icon"])])]), _createElementVNode("div", {
          class: "image-wrapper",
          ref_key: "cardImageRef",
          ref: cardImageRef
        }, [(_openBlock(), _createElementBlock("svg", {
          ref_key: "svgRef",
          ref: svgRef,
          class: "w-full",
          style: {
            height: '160px'
          }
        }, null, 512))], 512)]),
        _: 1
      });
    };
  }
});